import { render, staticRenderFns } from "./ChatViewer.vue?vue&type=template&id=3c7ff048&scoped=true"
import script from "./ChatViewer.vue?vue&type=script&lang=js"
export * from "./ChatViewer.vue?vue&type=script&lang=js"
import style0 from "./ChatViewer.vue?vue&type=style&index=0&id=3c7ff048&prod&lang=scss"
import style1 from "./ChatViewer.vue?vue&type=style&index=1&id=3c7ff048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7ff048",
  null
  
)

export default component.exports